$(document).ready(function(){

    // Select and loop the container element of the elements you want to equalise
    $('.home-slideshow-wrapper').each(function(){  
      
      // Cache the highest
      var highestBox = 0;
      
      // Select and loop the elements you want to equalise
      $('.item.image', this).each(function(){
        
        // If this box is higher than the cached highest then store it
        if($(this).height() > highestBox) {
          highestBox = $(this).height(); 
        }
      
      });  
            
      // Set the height of all those children to whichever was highest 
      $('.item.image',this).height(highestBox);
                    
    }); 

});

//GS! code STARTS
$(document).ready(function(){
  $('.gs-both-added').click(function(){ 
      $('.gs-add-trigger').trigger('click');
      setTimeout(function () {
        window.location.href = "/cart";
      }, 3000);
  }); 
});
//GS! code ENDS